
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteGoal } from "../database-goals";
import { goalQueryKeys } from "../operations/goal-query-keys";
import { useUser } from "@/hooks/auth/use-user";

export function useDeleteGoalMutation() {
  const queryClient = useQueryClient();
  const { user } = useUser();
  return useMutation({
    mutationFn: async (goalId: string) => {
      if (!user) throw new Error("Not signed in");
      return deleteGoal(goalId, user.id);
    },
    onSuccess: (_, goalId) => {
      if (!user) return;
      queryClient.invalidateQueries({ queryKey: goalQueryKeys.user(user.id) });
    }
  });
}
